import React, { useCallback, useState , useEffect } from "react";
import PageHeader from '../../components/Layout/PageHeader';
import DataTable , {createTheme} from 'react-data-table-component';
import Card from '../../components/Cards/Card.js';
import { Link , useNavigate } from "react-router-dom";
import swal from 'sweetalert';
import config from "../../constant/config";
import { ThemeContext } from '../../components/Layout/ThemeContext';




const Tables = () => {
  const axios = require('axios').default;
  const { theme, setTheme } = React.useContext(ThemeContext);
  const { themeBgColor, setThemeBgColor } = useState("#ffffff");
  const { themeTextColor, setThemeTextColor } = useState("#000000");
  const [isLoaded, setIsLoaded] = useState(false);
  const [chartType, setChartType] = useState("Bar");
  const [tankDiameterLabel, setTankDiameterLabel] = useState([]);
  const [tankDiameterValue, setTankDiameterValue] = useState([]);
  const [productCategoryLabel, setProductCategoryLabel] = useState([]);
  const [productCategoryValue, setProductCategoryValue] = useState([]);
  const [corrosionPatternLabel, setCorrosionPatternLabel] = useState([]);
  const [corrosionPatternValue, setCorrosionPatternValue] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);


  const getData = () => {
    fetch(`${config.baseUrl}/api/detects`)
      .then(res => res.json())
      .then(
        (result) => {
          var key;
          //console.log(result);
          setTableData(result);
          const td=groupBy(result, 'tank_diameter')
          const pc=groupBy(result, 'product_category')
          const cp=groupBy(result, 'corrosion_pattern')
          setTankDiameterLabel([]);
          setTankDiameterValue([]);
          for (key in td) {
            // if (td.hasOwnProperty(key)) {
            //     console.log("%c "+key + " = " + td[key].length,"color:cyan");
            // }
            setTankDiameterLabel((tankDiameterLabel) => [...tankDiameterLabel,key]);
            setTankDiameterValue((tankDiameterValue) => [...tankDiameterValue,td[key].length]);
            
          }
          setProductCategoryLabel([]);
          setProductCategoryValue([]);
          for (key in pc) {
            setProductCategoryLabel((productCategoryLabel) => [...productCategoryLabel,key]);
            setProductCategoryValue((productCategoryValue) => [...productCategoryValue,pc[key].length]);
          }
          setCorrosionPatternLabel([]);
          setCorrosionPatternValue([]);
          for (key in cp) {
            setCorrosionPatternLabel((corrosionPatternLabel) => [...corrosionPatternLabel,key]);
            setCorrosionPatternValue((corrosionPatternValue) => [...corrosionPatternValue,cp[key].length]);
          }
          setIsLoaded(true);
        },
        (error) => {
          setIsLoaded(true);
          //setError(error);
          console.log(error);
        }
      )
  };

  const columns = [
    {
      name: 'Action ',
      button: true,
      cell: row => (
        <div className="flex mr-3 ">
          <button onClick={()=>deleteConfirm(row.id)}
          target="_blank" 
          className='mr-1 order-0 inline-flex items-center p-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-purple-800 bg-purple-200 hover:bg-purple-700 focus:outline-none focus:ring-2 hover:text-white focus:ring-offset-2 focus:ring-purple-500'
          rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
          <Link to={'/Edit-Table/'+row.id} 
          className='mr-1 order-0 inline-flex items-center p-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-purple-800 bg-purple-200 hover:bg-purple-700 focus:outline-none focus:ring-2 hover:text-white focus:ring-offset-2 focus:ring-purple-500'
          rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
          </Link>
          
        </div>
      ),			
    },
    {
        name: 'Tank Id',
        selector: row => row.tank_id,
        sortable: true,
    },
    {
        name: 'Tank Diameter',
        selector: row => row.tank_diameter,
        sortable: true,
    },
    {
      name: 'Product Category',
      selector: row => row.product_category,
      sortable: true,
    },
    {
      name: 'Product',
      selector: row => row.product,
      sortable: true,
    },
    {
      name: 'Inspection Type',
      selector: row => row.inspection_type,
      sortable: true,
    },
    {
      name: 'Corrosion Pattern',
      selector: row => row.corrosion_pattern,
      sortable: true,
    },
  ];
  
   let lang = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of"
  };
    
  const deleteConfirm = (value) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        axios.delete(`${config.baseUrl}/api/detect/${value}`)
        .then(function (response) {
          console.log(response);
          getData();
          swal(response.data, {
            icon: "success",
          });
        })
        .catch(function (error) {
          //console.log(error);
          //console.log(error.response.data);
          swal("Oh noes!", error.response.data, "error");
        })
        .then(function () {
          // always executed
        })
      } 
    });
  };

  function groupBy(data, key) {
    return data.reduce((acc, x) => {
      acc[x[key]] = [...(acc[x[key]] || []), x];
      return acc;
    }, {});
  }

  useEffect(() => {
    console.log(theme);
    getData();
  }, [])

  const handleChange = useCallback(state => {
		setSelectedRows(state.selectedRows);
	}, []);
  
  createTheme(
    	'dark',
    	{
    		text: {
    			primary: themeTextColor,
    			secondary: themeTextColor,
    		},
    		background: {
    			default: themeBgColor,
    		},
    		context: {
    			background: '#cb4b16',
    			text: '#FFFFFF',
    		},
    		divider: {
    			default: '#073642',
    		},
    		button: {
    			default: '#2aa198',
    			hover: 'rgba(0,0,0,.08)',
    			focus: 'rgba(255,255,255,.12)',
    			disabled: 'rgba(255, 255, 255, .34)',
    		},
    		sortFocus: {
    			default: '#2aa198',
    		},
    	},
    	'dark',
    );

  if (!isLoaded) {
    return (
      <main className="flex-1 bg-slate-100">
        <PageHeader title={"Dashboard"} />
        <div class="flex flex-wrap mx-1 mt-6">
          <div class="w-full mt-6 px-2  xl:mt-0">
            <div class="bg-white m-4 rounded-md p-4 w-full mx-auto">
              <div class="animate-pulse flex space-x-4 ">
                <div class="flex-1 space-y-6 py-1">
                  <div class="h-2 bg-slate-200 rounded"></div>
                  <div class="space-y-3">
                    <div class="grid grid-cols-3 gap-4">
                      <div class="h-2 bg-slate-200 rounded col-span-2"></div>
                      <div class="h-2 bg-slate-200 rounded col-span-1"></div>
                    </div>
                    <div class="h-2 bg-slate-200 rounded"></div>
                  </div>
                </div>
              </div>

              <div class="animate-pulse flex space-x-4 ">
                <div class="flex-1 space-y-6 py-1">
                  <div class="h-2 bg-slate-200 rounded"></div>
                  <div class="space-y-3">
                    <div class="grid grid-cols-3 gap-4">
                      <div class="h-2 bg-slate-200 rounded col-span-2"></div>
                      <div class="h-2 bg-slate-200 rounded col-span-1"></div>
                    </div>
                    <div class="h-2 bg-slate-200 rounded"></div>
                  </div>
                </div>
              </div>

              <div class="animate-pulse flex space-x-4 ">
                <div class="flex-1 space-y-6 py-1">
                  <div class="h-2 bg-slate-200 rounded"></div>
                  <div class="space-y-3">
                    <div class="grid grid-cols-3 gap-4">
                      <div class="h-2 bg-slate-200 rounded col-span-2"></div>
                      <div class="h-2 bg-slate-200 rounded col-span-1"></div>
                    </div>
                    <div class="h-2 bg-slate-200 rounded"></div>
                  </div>
                </div>
              </div>

              <div class="animate-pulse flex space-x-4 ">
                <div class="flex-1 space-y-6 py-1">
                  <div class="h-2 bg-slate-200 rounded"></div>
                  <div class="space-y-3">
                    <div class="grid grid-cols-3 gap-4">
                      <div class="h-2 bg-slate-200 rounded col-span-2"></div>
                      <div class="h-2 bg-slate-200 rounded col-span-1"></div>
                    </div>
                    <div class="h-2 bg-slate-200 rounded"></div>
                  </div>
                </div>
              </div>

              <div class="animate-pulse flex space-x-4 ">
                <div class="flex-1 space-y-6 py-1">
                  <div class="h-2 bg-slate-200 rounded"></div>
                  <div class="space-y-3">
                    <div class="grid grid-cols-3 gap-4">
                      <div class="h-2 bg-slate-200 rounded col-span-2"></div>
                      <div class="h-2 bg-slate-200 rounded col-span-1"></div>
                    </div>
                    <div class="h-2 bg-slate-200 rounded"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className='flex-1'>
      <PageHeader title={'Tables'} showCreateButton={true} url='/Add-Table'/>
      <div className='px-4 mt-6 sm:px-6 lg:px-8 '>
        <Card>
          <DataTable
            class="dark:bg-slate-800"
            title="Tank Details"
            columns={columns}
            data={tableData}
            theme={theme}
            defaultSortField="title"
            onSelectedRowsChange={handleChange}
            pagination
            paginationComponentOptions={{
              rowsPerPageText: lang.rowsPerPageText,
              rangeSeparatorText: lang.rangeSeparatorText,
              noRowsPerPage: false
            }}
          />
        </Card>
      </div>
    </main>
  );
};

export default Tables;
